module.exports = __webpack_public_path__ + "static/media/ic-car.d737350a.svg";